import React from 'react'

import { Context } from './Context'

/**
 */
export const Provider = ({ optionGroup, children }) => (
  <Context.Provider value={{ optionGroup }}>{children}</Context.Provider>
)
